export default __webpack_public_path__ + "static/media/pictogramBeaconCertificateEducation48.957aa3e0.svg";